import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { LuMessageSquareMore, LuMic, LuMonitor, LuPhone } from "react-icons/lu";
import { HiOutlineSpeakerWave } from "react-icons/hi2";
import type { ReactNode } from "react";
import type { ContactType } from "./types";

const iconMap: Record<string, ReactNode> = {
  sms: <LuMessageSquareMore className="size-6 text-primary" />,
  inSystem: <LuMonitor className="size-6 text-primary" />,
  voice_call: <HiOutlineSpeakerWave className="size-6 text-primary" />,
  safe_call: <LuPhone className="size-6 text-primary" />,
  preRecordedVoice: <LuMic className="size-6 text-primary" />,
};

const OPTIONS: ContactType[] = [
  "sms",
  "inSystem",
  "voice_call",
  "preRecordedVoice",
  "safe_call",
];

interface Props {
  selected: ContactType;
  onSelect: (type: ContactType) => void;
  hiddenOptions?: ContactType[];
}

export function ContactTypeCards({
  selected,
  onSelect,
  hiddenOptions = [],
}: Props) {
  const { t } = useTranslation();

  const visibleOptions = OPTIONS.filter(
    (option) => !hiddenOptions.includes(option)
  );

  return (
    <div className="grid grid-cols-4 lg:grid-cols-5 gap-2 shrink-0">
      {visibleOptions.map((option) => (
        <div
          key={option}
          onClick={() => onSelect(option)}
          className={cn(
            "col-span-2 lg:col-span-1 p-3 border rounded-lg min-h-20 cursor-pointer transition-colors",
            selected === option
              ? "border-primary bg-primary/10"
              : "border-border hover:bg-secondary-hover"
          )}
        >
          <div className="flex items-center gap-2">
            <div
              className={cn(
                "w-4 h-4 rounded-full border-2 flex items-center justify-center",
                selected === option
                  ? "border-primary bg-primary"
                  : "border-muted-foreground/40 bg-transparent"
              )}
            >
              {selected === option && (
                <div className="w-2 h-2 rounded-full bg-primary-foreground" />
              )}
            </div>
          </div>
          <div className="flex flex-col items-center gap-1">
            {iconMap[option]}
            <span className="text-center text-sm">{t(option)}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
